const unloadingMethodsIds = {
  sideId: '2e2abc15-26c4-445e-9ba7-7c7281b0cc60',
  topId: '0840ea81-abe0-4c23-8807-b528fe924d24',
  platformId: '0b119f2f-4c44-4a95-9e6f-7d4d9a89c2aa',
  hdsId: 'e830f0a9-41ab-43da-8d82-8fc5db8efb69',
};

export default unloadingMethodsIds;
